'use client';
import useSWR from "swr";
import { resolveExchangeHistoricalNetworksURL } from "../helpers/routes";
import { useMemo } from "react";
import LayerSwapApiClient from "../lib/apiClients/layerSwapApiClient";
export default function useExchangeNetworks({ fromExchange, to, toAsset }) {
    const exchangeNetworksURL = resolveExchangeHistoricalNetworksURL("from", { fromExchange, to, toAsset });
    const apiClient = new LayerSwapApiClient();
    const { data: apiResponse, isLoading, isValidating } = useSWR(exchangeNetworksURL, apiClient.fetcher, {
        keepPreviousData: true,
        dedupingInterval: 10000,
        revalidateIfStale: false
    });
    //As the response does not give the statuses and it does not include not active tokens, we can assume all are active
    const networks = useMemo(() => (apiResponse?.data?.map(n => ({ ...n, token: { ...n.token, status: "active" } }))), [apiResponse]);
    return { networks, isLoading, isValidating };
}
